import { render, staticRenderFns } from "./SignupBox.vue?vue&type=template&id=54880213&"
import script from "./SignupBox.vue?vue&type=script&lang=js&"
export * from "./SignupBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports